var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 4.16732L13.8335 7.50065M13.8335 7.50065L10.5002 10.834M13.8335 7.50065H4.66683C3.78277 7.50065 2.93493 7.14946 2.30981 6.52434C1.68469 5.89922 1.3335 5.05137 1.3335 4.16732C1.3335 3.28326 1.68469 2.43542 2.30981 1.81029C2.93493 1.18517 3.78277 0.833984 4.66683 0.833984H5.50016",
    stroke: "#9CA1BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequested);
export default __webpack_public_path__ + "static/media/requested.330173e3e30760d52435ae67bf08ed3f.svg";
export { ForwardRef as ReactComponent };